/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import View from '../ViewComponents/View'

class PoiDetailComponent extends Component {

  getStyle () {
    return {
      outer: {
        padding: '10px 10px 0 10px',
        backgroundColor: '#E6E6E6',
        height: this.props.mapHeight,
        overflow: 'hidden',
        boxSizing: 'border-box',
        width: '100vw'
      },
      box: {
        backgroundColor: 'white',
        height: `calc(${this.props.mapHeight}px - 11px)`,  // = height - margin
        // width: 'calc(100% - 20px)',
        overflow: 'auto',
      }
    }
  }

  renderDetails (categoryConfig) {
    return (
      <div className={categoryConfig.cssClass}>
        <View
          config={categoryConfig.view}
          functions={this.props.functions}
          poi={this.props.poi}
        />
      </div>
    )
  }

  renderCategoryDetails (categoryConfig) {
    if (!Object.keys(categoryConfig).includes(this.props.poi.category)) {
      return null
    }

    const configForCategory = categoryConfig[this.props.poi.category]

    const categoryConfigToUse = typeof configForCategory.details === 'string'
      ? this.props.referencedConfigs[configForCategory.details]
      : configForCategory.details

    // console.log('categoryConfigToUse', categoryConfigToUse)

    return this.renderDetails(categoryConfigToUse)
  }

  render () {
    let details = this.renderCategoryDetails(this.props.config)

    let styles = this.getStyle()

    return (
      <div style={styles.outer}>
        <div style={styles.box}>
          {details}
        </div>
      </div>
    )
  }

}

PoiDetailComponent.propTypes = {
  poi: PropTypes.object.isRequired,
  mapHeight: PropTypes.number,
  functions: PropTypes.object.isRequired,
  config: PropTypes.object.isRequired,
  referencedConfigs: PropTypes.object
}

export default PoiDetailComponent



// WEBPACK FOOTER //
// ./src/components/TripAdvisor/PoiDetailComponent.js